import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Collapse } from '@material-ui/core';

import { RuleHeader } from './components/RuleHeader';
import { RuleDetails } from './components/RuleDetails';
import { useStyles } from './useStyles';

export const DetectedBrandTerm = ({
  className,
  brandTerm,
  termInText,
  onApplyClick,
  onEditClick,
  disabled,
  shrunk,
}) => {
  const styles = useStyles();

  const [expanded, setExpanded] = useState(false);

  const handleToggleDetails = useCallback(() => {
    setExpanded((prev) => !prev);
  }, []);

  return (
    <div className={cx(styles.root, className)}>
      <RuleHeader
        className={styles.header}
        brandTerm={brandTerm}
        termInText={termInText}
        onApplyClick={onApplyClick}
        expanded={expanded}
        onToggleDetails={handleToggleDetails}
        disabled={disabled}
        shrunk={shrunk}
      />

      <Collapse in={expanded}>
        <RuleDetails
          className={styles.details}
          brandTerm={brandTerm}
          onEditClick={onEditClick}
          disabled={disabled}
        />
      </Collapse>
    </div>
  );
};

DetectedBrandTerm.propTypes = {
  className: PropTypes.string,
  brandTerm: PropTypes.shape().isRequired,
  termInText: PropTypes.string.isRequired,
  onApplyClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func,
  disabled: PropTypes.bool,
  shrunk: PropTypes.bool,
};

DetectedBrandTerm.defaultProps = {
  className: '',
  onEditClick: null,
  disabled: false,
  shrunk: false,
};
